<h2 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragBoundary=".cdk-overlay-container" cdkDragHandle class="tt-secondary-background">
    {{ data.heading }}
</h2>
<mat-dialog-content style="display: flex; padding: 0; height: 100%; flex: 1; max-height: none; font-family: var(--tt-body-font-family)">
    <tt-report-preview [reportDefKeyno]="data.p2_reportdef_keyno" [reportTypeKeyno]="data.report_type_keyno" [parameters]="data.parameters"></tt-report-preview>
</mat-dialog-content>
